var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsOptional, IsUUID } from 'class-validator';
import { TrainingSessionItemEval } from '../enums/training-session-item-eval.enum.js';
export class TrainingSessionItemLiteDto {
    id;
    createdAt;
    updatedAt;
    exerciseProgramItemId;
    trainingSessionId;
    sortIndex;
    evaluation;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemLiteDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TrainingSessionItemLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TrainingSessionItemLiteDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemLiteDto.prototype, "exerciseProgramItemId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemLiteDto.prototype, "trainingSessionId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TrainingSessionItemLiteDto.prototype, "sortIndex", void 0);
__decorate([
    IsOptional(),
    IsEnum(TrainingSessionItemEval),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionItemLiteDto.prototype, "evaluation", void 0);
//# sourceMappingURL=training-session-item.lite.dto.js.map